// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","997":"component---src-templates-target-language-index-tsx"}[chunkId] || chunkId) + "-" + {"113":"18a34fd60829431fddc1","245":"f45471fdd4800d6fcf9b","453":"96bf43f9af3f1ad4834a","997":"487bc4f59b21dcc6ecf2"}[chunkId] + ".js";
};